
  import { Component, Prop, Vue } from "vue-property-decorator";
  import { OpenRequestService } from "@/services/admin";
  import dayjs from "dayjs";
  @Component({
    name: "test",
    components: {}
  })
  export default class componentCustom extends Vue {
    @Prop() email!: string;
    @Prop({ required: true, default: "user-request-modal" }) popupId!: string;
    selectAll: boolean = false;
    isLoading: boolean = false;
    saving: boolean = false;
    fields: any[] = [
      {
        key: "selected",
        label: "",
        tdClass: "columnCheckbox"
      },
      {
        key: "emailTo",
        label: "Retrieve Email To"
      },
      {
        key: "dateSent",
        label: "Date Requested"
      },
      {
        key: "comments",
        label: "Comments"
      }
    ];
    items: any[] = [];

    async onPopupShow() {
      this.isLoading = true;
      this.selectAll = false;
      const { status, data } = await OpenRequestService.GetOpenRequestByEmail(
        this.email
      );
      if (status === 200) {
        this.items = data.map(el => {
          el.selected = false;
          return el;
        });
      }

      this.isLoading = false;
    }

    onSelectAll() {
      let items = [...this.items];
      items = items.map(el => {
        el.selected = this.selectAll;
        return el;
      });
      this.items = [...items];
    }
    async save() {
      this.saving = true;
      const filteredEmail = this.items
        .filter(x => x.selected === true)
        .map(x => {
          return x.emailId;
        });
      await OpenRequestService.OpenRequestBlacklistMail(filteredEmail);
      this.generateSuccess(`Successfully send email requested`);
      this.saving = false;
      this.cancel();
    }
    cancel() {
      this.items = [];
      this.$bvModal.hide(this.popupId);
    }
    generateError(msg: string) {
      this.$bvToast.toast(`Error: ${msg}`, {
        title: "Error",
        variant: "danger",
        autoHideDelay: 5000
      });
    }
    generateSuccess(msg: string) {
      this.$bvToast.toast(`${msg}`, {
        title: "Information",
        variant: "primary",
        autoHideDelay: 5000
      });
    }

    getPostingDate(date: Date) {
      return dayjs(date).format("MM/DD/YYYY hh:mm A");
    }
  }
